declare const __APP_VERSION__: string;

const PRODUCTION_HOSTNAMES = ['nextproptrader.com', 'www.nextproptrader.com'];

export const isProduction = () => {
  try {
    return PRODUCTION_HOSTNAMES.includes(window.location.hostname);
  } catch {
    return false;
  }
};

export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0';

export const API_BASE = isProduction()
  ? 'https://api.nextproptrader.com'
  : 'https://api.staging.nextproptrader.com';

export const WS_BASE = isProduction()
  ? 'wss://ws.nextproptrader.com'
  : 'wss://ws.staging.nextproptrader.com';

